document.addEventListener('DOMContentLoaded', () => {
    // FAQ Search
    const FAQ_SEARCH_INPUT = document.querySelector('[data-search-faqs-value]');
    if(FAQ_SEARCH_INPUT) {
        FAQ_SEARCH_INPUT.addEventListener('input', function(e) {
            // Get the search input value only after 1sec pause in typing
            const SEARCH_QUERY = this.value.toLowerCase();
            const onInput = window.Arkhi.debounce(getFaqSearchResults, 1000);
            onInput(SEARCH_QUERY);
        })
    }

    const getFaqSearchResults = (query) => {
        const PARENTS = document.querySelectorAll('[data-faq-search-parent]');
        const FAQ_ITEMS = document.querySelectorAll('[data-faq-search]');
        const NO_RESULTS_DIV = document.querySelector('[data-search-faqs-no-results]');
        if(query != '') {
            // Search through each FAQ item to find FAQs that have the query value, and hide/show FAQS based on if they match
            FAQ_ITEMS.forEach(item => {
                const TEXT = item.textContent.toLowerCase();
                if (TEXT.includes(query)) {
                    item.classList.remove('hidden');
                    item.classList.add('search-visible');
                } else {
                    item.classList.add('hidden');
                    item.classList.remove('search-visible');
                }
            })
            // Seacrh through each of the parent FAQs to see if they have any visible FAQs and hide/show the relevant parents
            PARENTS.forEach(item => {
                const ACTIVE_SEARCH_RESULTS = item.querySelectorAll('.search-visible');
                if(ACTIVE_SEARCH_RESULTS.length) {
                    item.classList.remove('hidden');
                } else {
                    item.classList.add('hidden');
                }
            })
            // If there are no active results, display the no results div
            const ACTIVE_RESULTS = document.querySelectorAll('.search-visible');    
            if(ACTIVE_RESULTS.length) {
                NO_RESULTS_DIV.classList.add('hidden');
            } else {
                NO_RESULTS_DIV.classList.remove('hidden');
            }
        } else {
            // If the query is empty, return all FAQs and parents back to visible and hide the no results div
            PARENTS.forEach(item => {
                item.classList.remove('hidden');
            })
            FAQ_ITEMS.forEach(item => {
                item.classList.remove('hidden');
            });
            NO_RESULTS_DIV.classList.add('hidden');
        }
    }
})